module.exports = __webpack_public_path__ + "static/media/doughnut.dc068c96.svg";